import { inspectionSource } from 'serviceWorker/services/inspections/inspectionSource';
import { queueInspectionChanges } from 'serviceWorker/services/inspections/queueInspectionChanges';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { inspectionContract } from 'shared/domain/inspection/inspectionContract';
import { serveEntityRequests } from './serveEntityRequests';

/**
 * Answers the inspection requests: reads once the inspections are downloaded
 * (at once and empty for standard users), inspection and protocol changes
 * once queued (their outcome follows as an event with the change's `uniqueId`).
 */
export function serveInspectionRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(inspectionContract, inspectionSource),
    channelServer.handle(inspectionContract, {
      getOneById: ({ id }) => inspectionSource.getOneById(id),
      ...queueInspectionChanges,
    }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
